import React from 'react';
import { Section, Eyebrow } from '../Section';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
export function FinalCta() {
  return <Section data-id="element-140" data-mp="1nnycywb5vtmc">
      <Eyebrow data-id="element-141" data-mp="1noggme05la4a">Ready?</Eyebrow>
      <h2 className="mt-3 text-center font-display text-[30px] font-extrabold uppercase leading-[1.05] text-white sm:text-5xl" data-id="element-142" data-mp="1nn5cgd2sq0cn">
        The next time you turn on your welder…
      </h2>
      <p className="mt-4 text-center text-[15px] leading-relaxed text-zinc-300" data-id="element-143" data-mp="1en07saozlg26">
        You can keep guessing… or you can follow a clear decision system. Open Weld Decision
        System™, find the decision map you need, identify what you’re seeing and determine what to
        check next.
      </p>

      <p className="mt-6 text-center font-display text-3xl font-extrabold uppercase leading-tight text-flame-500 sm:text-4xl" data-id="element-144" data-mp="19rb3ju20vazj">
        Stop. Look. Decide. Weld.
      </p>

      <div className="mt-8 rounded-2xl border border-flame-500/40 bg-ink-800 p-5 text-center" data-id="element-145" data-mp="341wxg4xm45bx">
        <p className="font-display text-xl font-extrabold uppercase leading-tight text-white sm:text-2xl" data-id="element-146" data-mp="27trhx4bcrwu">
          Get Weld Decision System™ today
        </p>
        <p className="mt-2 font-display text-[64px] font-extrabold leading-[0.85] text-flame-500" data-id="element-147" data-mp="b16tdokcv3v2">
          $27 <span className="text-2xl text-white" data-id="element-148" data-mp="6zbibscmhc43">USD</span>
        </p>
        <p className="mt-3 text-[12px] font-semibold uppercase tracking-[0.12em] text-zinc-400" data-id="element-149" data-mp="727fvfkk5ys0">
          One-time payment · Instant access · Lifetime access · 7-day guarantee
        </p>

        <div className="mt-6" data-id="element-150" data-mp="3aimydjinpbem">
          <CTAButton label="I WANT THE WELD DECISION SYSTEM™" sub="" data-id="element-151" data-mp="3og3751ofdh9j" />
        </div>
        <div className="mt-6" data-id="element-152" data-mp="3jh8c91d6o292">
          <Countdown data-id="element-153" data-mp="3jgyw05hxx9gk" />
        </div>
        <div className="mt-6" data-id="element-154" data-mp="3jfx8v2nngwih">
          <ScarcityBar data-id="element-155" data-mp="13q40cvj49e8i" />
        </div>
      </div>
    </Section>;
}